export const colorConstant = () => {
    return {
        ypo_gold: '#D69D23',
        ypo_blue: '#083050',
        ypo_blue_secondary: '#4F90C4',
        ypo_blue_grey: '#8B939F',
        white: '#ffffff',
        ypo_cta: '#44779F',
        ypo_gray: '#8D9396',
        ypo_light_gray: '#EDEDED',
};
};
